export default "<div id=\"stage\" class=\"threejsRenderer dragdrop threejsRenderer\"></div>\n";